import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface AdminChartCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}

const AdminChartCard = ({ title, subtitle, children, className, action }: AdminChartCardProps) => {
  return (
    <div className={cn(
      'bg-card border border-border rounded-xl shadow-sm flex flex-col h-full',
      className
    )}>
      <div className="px-5 py-4 border-b border-border flex justify-between items-center">
        <div>
          <h3 className="text-base font-semibold text-foreground">{title}</h3>
          {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
        {action && <div>{action}</div>}
      </div>
      <div className="p-5 flex-1 min-h-[300px]">
        {children}
      </div>
    </div>
  );
};

export default AdminChartCard;
